<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Desde"
            label-for="fechaDesde"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="fechaDesde" 
              v-model= "filtro.fechaDesde" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Hasta"
            label-for="fechaHasta"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="fechaHasta" 
              v-model= "filtro.fechaHasta" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Cliente"
            label-for="cliente"
            :label-cols="2"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarCliente">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.cliente,
                                'fa fa-remove': filtro.cliente  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="cliente"
                :value="clienteNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label="Tipo de Artículo"
            label-for="articuloTipo"
            :label-cols="2"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarArticuloTipo">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.articuloTipo,
                                'fa fa-remove': filtro.articuloTipo  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="articuloTipo"
                :value="articuloTipoNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>  

          <b-form-group
            label="Proveedor"
            label-for="proveedor"
            :label-cols="2"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarProveedor">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.proveedor,
                                'fa fa-remove': filtro.proveedor  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="proveedor"
                :value="proveedorNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>  

          <b-form-group
            :label-cols= '2'
            horizontal>
            <b-form-checkbox 
                id="sortByDescending"
                v-model="filtro.sortByDescending"
                :value= "Boolean(true)"
                :unchecked-value= "Boolean(false)">
                Ordenar órdenes en forma descendente
            </b-form-checkbox>
          </b-form-group>
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <b-modal ref="searchArticuloTipoModal" 
        title="Seleccionar Tipo de Artículo"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-articulo-tipo
        @articuloTipoSeleccionado="articuloTipoSeleccionado">
      </app-search-articulo-tipo>  
    </b-modal>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        :incluirInactivos="true"
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import SearchArticuloTipo from '../articulosTipos/SearchList.vue';
import SearchProveedor from '../proveedores/SearchList.vue';
import moment from 'moment';

export default {
  components: {
    appSearchCliente: SearchCliente,
    appSearchArticuloTipo: SearchArticuloTipo,
    appSearchProveedor: SearchProveedor
  },
  props: {
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
    cliente: {
      type: Object,
      default: null
    },
    articuloTipo: {
      type: Object,
      default: null
    },
    proveedor: {
      type: Object,
      default: null
    },
    sortByDescending: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        cliente: null,
        articuloTipo: null,
        proveedor: null,
        sortByDescending: false
      },
      showOpcionesFiltro: Boolean(false)
    }
  },
  created() {
      this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
      this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
      this.filtro.cliente = this.cliente;
      this.filtro.articuloTipo = this.articuloTipo;
      this.filtro.proveedor = this.proveedor; 
      this.filtro.sortByDescending = this.sortByDescending;
  },
  computed: {
    'clienteNombre': function() {
      return this.filtro.cliente? this.filtro.cliente.nombre.trim() : '';
    },
    'articuloTipoNombre': function() {
      return this.filtro.articuloTipo? this.filtro.articuloTipo.nombre.trim() : '';
    },
    'proveedorNombre': function() {
      return this.filtro.proveedor? this.filtro.proveedor.nombre.trim() : '';
    },
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.cliente = null;
      this.filtro.articuloTipo = null;
      this.filtro.proveedor = null;
    },
    seleccionarCliente() {
      if (this.filtro.cliente) {
        this.filtro.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.filtro.cliente = cliente;
      this.$refs.searchClienteModal.hide();
    },
    seleccionarProveedor() {
      if (this.filtro.proveedor) {
        this.filtro.proveedor = null;
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(proveedor) {
      this.filtro.proveedor = proveedor;
      this.$refs.searchProveedorModal.hide();
    },
    seleccionarArticuloTipo() {
      if (this.filtro.articuloTipo) {
        this.filtro.articuloTipo = null;
      } else {
        this.$refs.searchArticuloTipoModal.show();
      }
    },
    articuloTipoSeleccionado(articuloTipo) {
      this.filtro.articuloTipo = articuloTipo;
      this.$refs.searchArticuloTipoModal.hide();
    },
  },
}
</script>

<style>
</style>
